import React from "react";
import { NavLink } from "react-router-dom";

interface RegistrationNavLinksProps {
    id: string;
    path: string;
    tabLabel: string;
}

//show the third tab on the registration container which is hidden by default
//style guide uses id to display custom sites
const RegistrationNavLink = ({ path, tabLabel, id }: RegistrationNavLinksProps) => {
    return (
        <li id={id} data-testid="registration-nav-link" role="tab" className="register-tab">
            <NavLink to={path} end>
                {tabLabel}
            </NavLink>
        </li>
    );
};

export default RegistrationNavLink;
